
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/jfe",
      function () {
        return require("private-next-pages/cases/jfe/index.tsx");
      }
    ]);
  